/* import __COLOCATED_TEMPLATE__ from './transfers-primer-step.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { assertNonNullable } from '@banking/ui/utils/assert';
let TransfersPrimerStep = (_class = class TransfersPrimerStep extends Component {
  get primaryButton() {
    return assertNonNullable(this.args.step.transfersPrimer?.primaryButton);
  }
  get doNotShowAgainButton() {
    return this.args.step.transfersPrimer?.doNotShowAgainButton;
  }
  handleContinue() {
    this.args.updateStep(this.primaryButton, {
      doNotShowAgainClicked: false
    });
  }
  handleDoNotShowAgain() {
    this.args.updateStep(this.doNotShowAgainButton, {
      doNotShowAgainClicked: true
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "handleContinue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleContinue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDoNotShowAgain", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDoNotShowAgain"), _class.prototype), _class);
export { TransfersPrimerStep as default };